import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import CustomSelect from '../../../components/ui/CustomSelect';

interface Relation {
  type: string;
  name: string;
  birth_info: string;
  relation: string;
  photo_url: string;
}

interface Step7Props {
  relations: Relation[];
  onAdd: () => void;
  onUpdate: (index: number, field: string, value: string) => void;
  onRemove: (index: number) => void;
}

export default function Step7Relations({ relations, onAdd, onUpdate, onRemove }: Step7Props) {
  return (
    <div className="space-y-4">
      {relations.map((relation, index) => (
        <div key={index} className="border rounded-lg p-4 space-y-3">
          <div className="flex justify-between items-start">
            <h4 className="font-medium">Relasi #{index + 1}</h4>
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="p-1 text-red-500 hover:bg-red-50 rounded"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>

          <div className="grid md:grid-cols-2 gap-3">
            <CustomSelect
              value={relation.type}
              onChange={v => onUpdate(index, 'type', v)}
              placeholder="Tipe"
              width="w-full"
              color="blue"
              options={[
                { value: 'individual', label: 'Perorangan' },
                { value: 'corporate', label: 'Badan Usaha' },
              ]}
            />

            <input
              type="text"
              placeholder="Nama"
              value={relation.name}
              onChange={e => onUpdate(index, 'name', e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />

            <input
              type="text"
              placeholder="Tempat & Tanggal Lahir"
              value={relation.birth_info}
              onChange={e => onUpdate(index, 'birth_info', e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />

            <input
              type="text"
              placeholder="Relasi dengan Debitur"
              value={relation.relation}
              onChange={e => onUpdate(index, 'relation', e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />

            <input
              type="file"
              accept="image/*"
              className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={onAdd}
        className="w-full flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-colors"
      >
        <Plus className="w-4 h-4" /> Tambah Relasi
      </button>
    </div>
  );
}
